import { notificationsProvider } from "./providers/notifications";
import {
  parseNotificationsListResponse,
  validateNotificationsListRequest,
  validateNotificationsStateRequest,
} from "./schemas/notificationsSchemas";

function normalizeListResponseBody(body) {
  if (!body || typeof body !== "object") return {};
  const total = body.totalCount ?? body.total_count;
  return {
    ...body,
    totalCount: total != null ? Number(total) : 0,
    page: body.page != null ? Number(body.page) : 0,
    size: body.size != null ? Number(body.size) : 0,
    items: Array.isArray(body.items) ? body.items : [],
  };
}

const notificationsService = {
  list: async (data, options) => {
    const payload = validateNotificationsListRequest(data);
    const response = await notificationsProvider.list(payload, options);
    const body = normalizeListResponseBody(response?.data);
    return parseNotificationsListResponse(body);
  },
  state: async (data) => {
    const payload = validateNotificationsStateRequest(data);
    return notificationsProvider.state(payload);
  },
};

export default notificationsService;
